<template>
  <div class="reserve">
    <div class="reserve-form">
      <!-- <el-form
        ref="form"
        :model="searchForm"
        size="small"
        label-width="80px"
      >
        <el-form-item label="预约日期">
          <el-date-picker
            v-model="searchForm.date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            :clearable="false"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="类别">
          <el-select
            v-model="searchForm.visitType"
            placeholder="请选择类别"
          >
            <el-option
              v-for="item in visitTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="医生">
          <el-select
            v-model="searchForm.doctorName"
            placeholder="请选择类别"
          >
            <el-option
              v-for="item in doctorList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="医疗机构">
          <el-radio-group v-model="searchForm.hospitalArea">
            <el-radio
              label="10001"
              value="10001"
            >新永门诊部</el-radio>
            <el-radio
              label="10002"
              value="10002"
            >新太门诊部</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="search"
          >搜索</el-button>
        </el-form-item>
      </el-form> -->
      <van-form @submit="search">
        <van-field
          readonly
          clickable
          name="datetimePicker"
          :value="searchForm.dateString"
          right-icon="arrow"
          label="预约日期"
          placeholder="点击选择预约日期"
          @click="dateShow = true"
        />
        <van-popup
          v-model="dateShow"
          position="bottom"
        >
          <van-calendar
            v-model="dateShow"
            :max-range="30"
            :default-date="searchForm.date"
            :allow-same-day="true"
            @confirm="onDateConfirm"
            type="range"
          />
        </van-popup>
        <!-- <van-field
          readonly
          clickable
          name="picker"
          :value="searchForm.visitTypeString"
          label="业务模块"
          right-icon="arrow"
          placeholder="点击选择业务模块"
          @click="showTypePicker = true"
        />
        <van-popup
          v-model="showTypePicker"
          position="bottom"
        >
          <van-picker
            show-toolbar
            value-key="label"
            :columns="visitTypeList"
            @confirm="onVisitTypeConfirm"
            @cancel="showTypePicker = false"
          />
        </van-popup> -->
        <!-- <van-field
          readonly
          clickable
          name="picker"
          :value="searchForm.doctorNameShow"
          label="医生"
          right-icon="arrow"
          placeholder="点击选择医生"
          @click="showDoctorPicker = true"
        />
        <van-popup
          v-model="showDoctorPicker"
          position="bottom"
        >
          <van-picker
            show-toolbar
            value-key="label"
            :columns="doctorList"
            @confirm="onDoctorConfirm"
            @cancel="showDoctorPicker = false"
          />
        </van-popup>
        <van-field
          name="radio"
          label="医疗机构"
        >
          <template #input>
            <el-radio-group v-model="searchForm.hospitalArea">
              <el-radio
                label="10001"
                value="10001"
              >新永门诊部</el-radio>
              <el-radio
                label="10002"
                value="10002"
              >新太门诊部</el-radio>
              <el-radio
                label="10003"
                value="10003"
              >健康中心</el-radio>
            </el-radio-group>
          </template>
        </van-field> -->
        <!-- <div style="margin: 16px;">
          <el-button
            type="primary"
            size="small"
            round
            @click="search"
            :loading="loading"
          >搜索</el-button>
        </div> -->

      </van-form>
      <div class="reserve-options">
        <el-radio-group
          v-model="searchForm.visitType"
          size="small"
          fill="#e7635e"
          @change="visitTypeChange"
        >
          <el-radio-button
            v-for="item in visitTypeList"
            :key="item.value"
            :label="item.value"
          >{{ item.label }}{{ item.count }}</el-radio-button>
        </el-radio-group>
        <el-button
          v-if="!isMobile"
          type="primary"
          class="reserve-export"
          @click="exportTable"
        >导出</el-button>
      </div>
      <!-- <div
        class="reserve-title"
        v-html="title"
      >
      </div> -->
    </div>
    <div
      v-if="isMobile"
      class="reserve-table-mobile"
    >
      <van-collapse
        v-model="activeNames"
        accordion
      >
        <van-collapse-item
          v-for="(item, index) in tableData"
          :name="index"
          :key="index"
        >
          <template #title>
            <div class="reserve-table-mobile-item-title">
              <div class="reserve-table-mobile-item-title-left">
                <div class="reserve-table-mobile-item-title-name">
                  {{ item.patientName }} ({{ item.levelDesc }}) {{ item.visitType }}
                </div>
                <div>
                  {{ item.appointmentDate }} {{  item.startTime  }}-{{  item.endTime  }}
                </div>
              </div>
              <div class="reserve-table-mobile-item-title-right">
                <div>
                  {{ item.itemName }}
                </div>
                <div>

                </div>

              </div>
            </div>
          </template>

          <div class="reserve-table-mobile-item-content">
            <!-- <div class="reserve-table-mobile-item-content-infor">
              <div class="reserve-table-mobile-item-content-lable">
                预约日期
              </div>
              <div class="reserve-table-mobile-item-content-text">
                {{  item.appointmentDate  }}
              </div>
            </div>
            <div class="reserve-table-mobile-item-content-infor">
              <div class="reserve-table-mobile-item-content-lable">
                预约时间段
              </div>
              <div class="reserve-table-mobile-item-content-text">
                {{  item.startTime  }} - {{  item.endTime  }}
              </div>
            </div> -->
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="reserve-table-mobile-item-content-infor">
                  <div class="reserve-table-mobile-item-content-lable">
                    性别
                  </div>
                  <div class="reserve-table-mobile-item-content-text">
                    {{  item.sex  }}
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="reserve-table-mobile-item-content-infor">
                  <div class="reserve-table-mobile-item-content-lable">
                    年龄
                  </div>
                  <div class="reserve-table-mobile-item-content-text">
                    {{  item.ageDesc  }}
                  </div>
                </div>
              </el-col>
            </el-row>

            <div class="reserve-table-mobile-item-content-infor">
              <div class="reserve-table-mobile-item-content-lable">
                体检套餐
              </div>
              <div class="reserve-table-mobile-item-content-text">
                {{  item.packagename  }}
              </div>
            </div>
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="reserve-table-mobile-item-content-infor">
                  <div class="reserve-table-mobile-item-content-lable">
                    家庭医生
                  </div>
                  <div class="reserve-table-mobile-item-content-text">
                    {{  item.familyDoctor  }}
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="reserve-table-mobile-item-content-infor">
                  <div class="reserve-table-mobile-item-content-lable">
                    服务管家
                  </div>
                  <div class="reserve-table-mobile-item-content-text">
                    {{  item.serviceManager  }}
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="reserve-table-mobile-item-content-infor">
                  <div class="reserve-table-mobile-item-content-lable">
                    渠道
                  </div>
                  <div class="reserve-table-mobile-item-content-text">
                    {{  item.channelName  }}
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="reserve-table-mobile-item-content-infor">
                  <div class="reserve-table-mobile-item-content-lable">
                    医助
                  </div>
                  <div class="reserve-table-mobile-item-content-text">
                    {{  item.medicalAssistance  }}
                  </div>
                </div>
              </el-col>
            </el-row>

            <div class="reserve-table-mobile-item-content-infor">
              <div class="reserve-table-mobile-item-content-lable">
                备注
              </div>
              <div class="reserve-table-mobile-item-content-text">
                {{  item.remark  }}
              </div>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>

    <div
      v-else
      class="reserve-table"
    >
      <el-table
        :data="tableData"
        height="100%"
        border
        style="width: 100%"
        size="small"
        row-key="appointmentNo"
      >
        <el-table-column
          prop="appointmentDate"
          label="预约日期"
          width="100px"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="预约时段"
          width="100px"
        >
          <template slot-scope="scope">
            {{ scope.row.startTime }}-{{ scope.row.endTime }}
          </template>
        </el-table-column>
        <el-table-column
          prop="patientName"
          label="姓名"
          width="100px"
        >
        </el-table-column>
        <el-table-column
          prop="sex"
          label="性别"
          width="50px"
        >
        </el-table-column>
        <el-table-column
          prop="ageDesc"
          label="年龄"
          width="50px"
        >
        </el-table-column>

        <el-table-column
          prop="levelDesc"
          label="会员等级"
          width="70px"
        >
        </el-table-column>
        <el-table-column
          prop="channelName"
          label="渠道"
          width="70px"
        >
        </el-table-column>
        <el-table-column
          prop="itemName"
          label="科室"
          width="100px"
        >
        </el-table-column>
        <el-table-column
          prop="visitType"
          label="就诊原因"
          min-width="170"
        >
        </el-table-column>
        <el-table-column
          prop="familyDoctor"
          label="家庭医生"
          min-width="80"
        >
        </el-table-column>
        <el-table-column
          prop="serviceManager"
          label="服务管家"
          min-width="80"
        >
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
        >
        </el-table-column>
        <el-table-column
          prop="packagename"
          label="套餐名称"
          min-width="170"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import getUserInfo from "@/models/userInfo";
import workService from "@/apis/work/index.js";
import { Message } from "element-ui";
import * as XLSX from "xlsx";

let originList = [];

const visitTypeMap = {
  10001: {
    hospitalName: "新永门诊部",
    visitTypeList: [
      {
        label: "全部",
        value: -1,
      },
      {
        label: "上午体检",
        value: 1,
      },
      {
        label: "下午专筛",
        value: 2,
      },
      {
        label: "内镜中心",
        value: 3,
      },
      {
        label: "全科门诊",
        value: 4,
      },
      {
        label: "妇科门诊",
        value: 5,
      },
      {
        label: "儿科中心",
        value: 6,
      },
      {
        label: "口腔中心",
        value: 7,
      },
      {
        label: "医美中心",
        value: 8,
      },
      {
        label: "日间手术中心",
        value: 9,
      },
      {
        label: "疫苗中心",
        value: 10,
      },
      {
        label: "沙龙活动",
        value: 11,
      },
    ],
  },
  10002: {
    hospitalName: "新太门诊部",
    visitTypeList: [
      {
        label: "全部",
        value: -1,
      },
      {
        label: "专家看诊",
        value: 1,
      },
      {
        label: "心理专家看诊",
        value: 2,
      },
      {
        label: "肿瘤看诊",
        value: 3,
      },
      {
        label: "MDT国内会诊",
        value: 4,
      },
      {
        label: "MDT国际会诊",
        value: 5,
      },
      {
        label: "瑞金医院住院转诊一体化",
        value: 6,
      },
      {
        label: "非瑞金医院住院转诊一体化",
        value: 7,
      },
      {
        label: "沙龙活动",
        value: 8,
      },
    ],
  },
  10003: {
    hospitalName: "健康中心",
    visitTypeList: [
      {
        label: "全部",
        value: -1,
      },
    ],
  },
};

export default {
  data() {
    return {
      isMobile: /Android|webOS|iPhone|iPod|BlackBerry/i.test(
        navigator.userAgent
      ),
      activeNames: [],
      title: "",
      dateShow: false,
      showTypePicker: false,
      showDoctorPicker: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() + 86400000 < Date.now();
        },
      },
      searchForm: {
        date: [
          new Date(moment().add(1, "days").format("YYYY-MM-DD")),
          new Date(moment().add(1, "days").format("YYYY-MM-DD")),
        ],
        visitType: -1,
        visitTypeString: "全部",
        hospitalArea: "10001",
      },
      tableData: [],
      visitTypeList: [],
      doctorList: [
        {
          label: "全部",
          value: "",
        },
      ],
      loading: false,
    };
  },
  watch: {
    searchForm: {
      handler(newVal) {
        this.searchForm.dateString = `${moment(newVal.date[0]).format(
          "YYYY-MM-DD"
        )}至${moment(newVal.date[1]).format("YYYY-MM-DD")}`;
      },
      immediate: true,
      deep: true,
    },
  },
  async created() {
    this.init();
    const userInfo = await getUserInfo();
    this.doctorList.push({
      label: userInfo.user_name,
      value: userInfo.user_name,
    });
    this.currentUserInfo = userInfo;
    this.getTableList();
  },
  methods: {
    exportTable() {
      // 假设 tableData 是需要导出的数据
      const data = this.tableData.map((item) => ({
        // 将需要的字段映射到 Excel 的列
        预约日期: item.appointmentDate,
        预约时段: `${item.startTime}-${item.endTime}`,
        姓名: item.patientName,
        性别: item.sex,
        年龄: item.ageDesc,
        会员等级: item.levelDesc,
        渠道: item.channelName,
        科室: item.itemName,
        就诊原因: item.visitType,
        家庭医生: item.familyDoctor,
        服务管家: item.serviceManager,
        备注: item.remark,
        套餐名称: item.packagename,
        // 添加更多字段
      }));

      // 1. 将数据转换为工作簿
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // 2. 导出 Excel 文件
      XLSX.writeFile(workbook, "tableData.xlsx");
    },
    visitTypeChange(value) {
      this.tableData = originList.filter((item) => {
        return value == -1 || item.plate == value;
      });
    },
    onDateConfirm(date) {
      this.searchForm.date = date;
      this.dateShow = false;
      this.search();
    },
    onVisitTypeConfirm(item) {
      const { searchForm } = this;
      searchForm.visitTypeString = item.label;
      searchForm.visitType = item.value;
      this.showTypePicker = false;
    },
    onDoctorConfirm(item) {
      const { searchForm } = this;
      searchForm.doctorName = item.value;
      searchForm.doctorNameShow = item.label;
      this.showDoctorPicker = false;
    },
    init() {
      const query = this.$route.query;
      const { searchForm } = this;
      if (query.date) {
        this.searchForm.date = [new Date(query.date), new Date(query.date)];
      }
      if (query.hospitalArea) {
        searchForm.hospitalArea = query.hospitalArea;
      }
      this.visitTypeList = visitTypeMap[searchForm.hospitalArea].visitTypeList;
    },
    search() {
      const { searchForm } = this;
      const date = searchForm.date;
      if (moment(date[1]).isAfter(moment(date[0]).add(1, "months"))) {
        Message({
          message: "最多查询时间范围为一个月",
          type: "warning",
        });
        return;
      }
      this.getTableList();
    },
    getTableList() {
      const { searchForm, visitTypeList } = this;
      const params = {
        startTime: moment(searchForm.date[0]).format("YYYY-MM-DD"),
        endTime: moment(searchForm.date[1]).format("YYYY-MM-DD"),
        ...searchForm,
        visitType: -1,
      };
      this.loading = true;
      workService
        .workGetHisApppointmentList(params)
        .then((res) => {
          visitTypeList.forEach((item) => (item.count = 0));
          res.lst.forEach((item) => {
            visitTypeList.some((option) => {
              if (option.value == item.plate) {
                option.count++;
                return true;
              }
            });
          });
          visitTypeList[0].count = res.lst.length;
          // this.tableData = this.sortAppointments(res.lst);
          originList = this.sortAppointments(res.lst);
          this.visitTypeChange(searchForm.visitType);
          this.title = res.title;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    sortAppointments(appointments) {
      // 创建一个新数组，包含所有levelDesc为'C级'的元素
      const cLevelAppointments = appointments.filter(
        (appointment) => appointment.levelDesc === "O类"
      );

      // 创建一个新数组，包含所有其他元素
      const otherAppointments = appointments.filter(
        (appointment) => appointment.levelDesc !== "O类"
      );

      // 将cLevelAppointments数组和otherAppointments数组合并
      return [...cLevelAppointments, ...otherAppointments];
    },
  },
};
</script>

<style lang="scss">
.reserve {
  height: 100%;
  overflow: hidden;
  // overflow: scroll;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .reserve-options {
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .reserve-export {
      width: 100px;
    }
  }

  .el-button {
    width: 100%;
    background-color: #e7635e;
    border: none;
  }
  .reserve-title {
    margin-bottom: 10px;
    color: #e7635e;
    min-height: 40px;
  }
  .reserve-table {
    flex: 1;
    overflow: hidden;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
  .el-date-editor.el-input__inner {
    width: 220px;
  }
  .reserve-table-mobile {
    flex: 1;
    overflow: scroll;
  }
  .van-cell {
    align-items: center;
  }
  .reserve-table-mobile-item-title-name {
    font-size: 15px;
    font-weight: 600;
  }
  .reserve-table-mobile-item-title {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    align-items: center;
    .reserve-table-mobile-item-title-right {
      text-align: right;
      flex-shrink: 0;
      font-size: 15px;
    }
  }
  .reserve-table-mobile-item-content-infor {
    display: flex;
    padding: 3px 0;
    .reserve-table-mobile-item-content-lable {
      width: 60px;
      flex-shrink: 0;
      color: #999;
    }
    .reserve-table-mobile-item-content-text {
      text-align: left;
      color: #000;
    }
  }
  // .van-cell::after {
  //   display: none;
  // }
  .van-collapse-item--border::after {
    border-top: 4px solid #eee;
    left: 0;
    right: 0;
  }
  .van-collapse-item__content {
    // padding-top: 0;
    font-size: 12px;
  }
}
</style>